import { render, staticRenderFns } from "./StockChange.vue?vue&type=template&id=e876caaa&scoped=true"
import script from "./StockChange.vue?vue&type=script&lang=js"
export * from "./StockChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e876caaa",
  null
  
)

export default component.exports